import type {z} from "zod";
import {EditExpedientNoteBody} from "@project/sdk/sales/zod";
import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

export const editExpedientNoteTitleSchema = requiredStringSchema(
  EditExpedientNoteBody.shape.title,
  noteFieldLabelIds.title,
);
export const editExpedientNoteContentSchema = requiredStringSchema(
  EditExpedientNoteBody.shape.content,
  noteFieldLabelIds.content,
);
export const editExpedientNoteFormSchema = EditExpedientNoteBody.strict().extend({
  title: editExpedientNoteTitleSchema,
  content: editExpedientNoteContentSchema,
});
export type EditExpedientNoteFormPayload = z.output<typeof editExpedientNoteFormSchema>;
export const draftEditExpedientNoteFormSchema = editExpedientNoteFormSchema.partial();
export type DraftEditExpedientNoteFormPayload = z.output<typeof draftEditExpedientNoteFormSchema>;
